import { render } from "./MainServersComponent.vue?vue&type=template&id=9ebcd3ec&scoped=true"
import script from "./MainServersComponent.vue?vue&type=script&lang=js"
export * from "./MainServersComponent.vue?vue&type=script&lang=js"

import "./MainServersComponent.vue?vue&type=style&index=0&id=9ebcd3ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ebcd3ec"]])

export default __exports__